import React from 'react';

const DeleteProfile = ({deleteProfile}) => {
    return (
        <a onClick={deleteProfile}> Delete profile</a>
    )
}

export default DeleteProfile;


// WEBPACK FOOTER //
// ./src/components/Admin/Profile/DeleteProfile.js